import React, {forwardRef, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {buildInteractionIdProps} from '../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {maybeAddWorkspaceDropLineStyle} from './line/workspaceLineStyles';

/*
 * Props.
 */

interface WorkspaceProps {
  isExpanded: boolean;
  interactionId?: string;
}

/*
 * Style.
 */

const StyledWorkspaceDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  margin-top: 20px;

  &:first-child {
    margin-top: 4px;
  }

  ${maybeAddWorkspaceDropLineStyle({
    indentLevel: 1,
    chevronWidth: 0,
    indentPaddingFactor: 18,
  })};
`;

/*
 * Component.
 */

export const Workspace = forwardRef<HTMLDivElement, PropsWithChildren<WorkspaceProps>>(
  ({interactionId, children}, ref) => (
    <StyledWorkspaceDiv ref={ref} {...buildInteractionIdProps(interactionId)}>
      {children}
    </StyledWorkspaceDiv>
  ),
);
